// extracted by mini-css-extract-plugin
export default {"outer-box":"I0j3dMlo9YRQ_1m4_lri","outer-box-main":"LRxrHAcKt1YWtzEV1AEg","hover-move-top":"SZJBIWeQiGFktVTDeUoj","common_bganimation":"A_OLh1PrUkxDreMW0TwG"};